type TDomain = [number, number];
type TRange = [number, number];

export const getLinearScaleFunction = function (domain: TDomain, range: TRange, valueAllowedRange: (null | number)[] = [null, null]) {
    const [domainStart, domainStop] = domain;
    const [rangeStart, rangeStop] = range;

    return function scale(value: number) {
        const domainRange = domainStop - domainStart;
        const isDomainRangeZero = domainRange === 0;

        /**
         * Handle cases where we have no range. i.e we have only one value or 3 values that are the same.
         * In this case, we cannot divide by 0 and have to use the other way to decide the position of the average.
         * In this case, upper and lower range of the domain are the same number
         *
         * If we have no range and the value passed is larger than the upper range, we want to move the point to the right to visualize it is larger than the median
         * */
        if (isDomainRangeZero && value > domainStart) {
            return rangeStop + rangeStop * 0.25;
        }

        // If we have no range and the value is smaller then the upper range we want to move the point to the right to visualise it is smaller then the median
        if (isDomainRangeZero && value < domainStart) {
            return rangeStart - rangeStart * 0.25;
        }

        // In this case we can have either one number or array of the same number. In this case we want to set the point in the middle to show it is not larger/smaller
        if (isDomainRangeZero) {
            return (rangeStart + rangeStop) / 2;
        }

        const result = rangeStart + (rangeStop - rangeStart) * ((value - domainStart) / domainRange);

        // Make sure value does not exceed allowed range and does not overflow the container
        const [lowestAllowedValue, largestAllowedValue] = valueAllowedRange;
        if (!!lowestAllowedValue && result < lowestAllowedValue) {
            return lowestAllowedValue;
        }

        if (!!largestAllowedValue && result > largestAllowedValue) {
            return largestAllowedValue;
        }

        return result;
    };
};
